let env = process.env.NODE_ENV === 'development' ? 'dev' : 'prod'
// env = 'prod'
export const api_base = env === 'dev' ? "http://localhost:5020" : 'https://said-sm.eaconsultores.com.co'

export const LOCAL_STORAGE = 'smStorage'
